module.exports = __webpack_public_path__ + "static/media/keystone.3779cc86.svg";